<template>
	<div
		class="event-infos"
		:class="{'-large': large, 'is-embed': isEmbed, '-feed-card': isFeedCard}"
	>
		<div class="event-infos__text">
			<!-- eslint-disable vue/no-v-html -->
			<div
				v-if="title"
				class="event-infos__title"
				v-html="title"
			/>
			<div
				v-if="subTitle"
				class="event-infos__subtitle"
			>
				{{ subTitle }}
			</div>
			<div
				v-if="meta"
				class="event-infos__meta"
			>
				{{ meta }}
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name:  'EventInfos',
	props: {
		title: {
			type:    String,
			default: null,
		},
		subTitle: {
			type:    String,
			default: null,
		},
		meta: {
			type:    String,
			default: null,
		},
		large: {
			type:    Boolean,
			default: false,
		},
		isEmbed: {
			type:    Boolean,
			default: false,
		},
		isFeedCard: {
			type:    Boolean,
			default: false,
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.event-infos {
	display: flex;
}

.event-infos__text {
	display: flex;
	flex-direction: column;
	justify-content: center;
	color: var(--color-soft-white);
	overflow: auto;

	.event-infos:not(.-large) & {
		body.-t-light & { // stylelint-disable-line selector-no-qualifying-type, selector-max-type, max-nesting-depth
			color: var(--color-shadow-grey);
		}
	}
}

.event-infos__title {
	@include font(primary, medium, normal, fs-100);
	@include line-clamp(2);
	margin-bottom: $sp1;

	.event-infos.-feed-card & {
		@include font(primary, medium, normal, fs-130);
		margin-bottom: $sp2;
	}
}

.event-infos__subtitle {
	@include font(primary, book, normal, fs-80);
	@include line-clamp(1);
	margin-bottom: $sp2-5;

	.event-infos.-feed-card & {
		@include font(primary, book, normal, fs-100);
	}
}

.event-infos__meta {
	@include font(primary, book, normal, fs-60);
	@include line-clamp(1);
	color: var(--color-grey-300);

	.event-infos.-large & {
		body.-t-light & { // stylelint-disable-line selector-no-qualifying-type, selector-max-type, max-nesting-depth
			color: var(--color-grey-700);
		}
	}

	.event-infos.-feed-card & {
		@include font(primary, book, normal, fs-80);
	}
}
</style>
